import React, { useState } from "react";
import RCSStandaloneMsg from "./RCSStandaloneMsg";

const tabs = [
  { id: "STANDALONE_SEND", label: "Send Message" },
  { id: "STANDALONE_REPLY", label: "Suggested Reply" },
  { id: "STANDALONE_CALENDAR", label: "Calendar Event" },
  { id: "STANDALONE_LOCATION", label: "Share Location" },
  { id: "STANDALONE_DIALER", label: "Dialer Action" },
  { id: "STANDALONE_OPENURL", label: "Open URL" },
  { id: "STANDALONE_COMBINED", label: "Combined" },
  // { id: "STANDALONE_SEND", label: "Message with Name" },
];

const RCSStandalone = () => {
  const [activeTab, setActiveTab] = useState("STANDALONE_SEND");
  const [activeLabel, setActiveLabel] = useState("Send Message");

  const wrapperStyle = {
    borderBottom: "1px solid #e4e4e4",
    backgroundColor: "#f3f4f6",
    paddingLeft: "16px",
    paddingTop: "10px",
  };

  const tabStyle = {
    padding: "8px 20px",
    border: "none",
    outline: "none",
    borderTopLeftRadius: "6px",
    borderTopRightRadius: "6px",
    backgroundColor: "#ffffff",
    color: "#000",
    fontWeight: "bold",
    cursor: "pointer",
    fontSize: "14px",
    marginRight: "0px",
    position: "relative",
    top: "1px",
    zIndex: 1,
  };

  const activeTabStyle = {
    ...tabStyle,
    backgroundColor: "#00bcd4",
    color: "#fff",
    zIndex: 2,
  };

  return (
    <div>
      {/* Tabs wrapper with border */}
      <div style={wrapperStyle}>
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          {tabs.map((tab) => (
            <button
              key={tab.id}
              style={
                activeTab === tab.id && activeLabel === tab.label
                  ? activeTabStyle
                  : tabStyle
              }
              onClick={() => {
                setActiveTab(tab.id);
                setActiveLabel(tab.label);
              }}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div style={{ padding: "16px" }}>
        <RCSStandaloneMsg activeTab={activeTab} activeLabel={activeLabel} />
      </div>
    </div>
  );
};

export default RCSStandalone;
